import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import ids from 'Components/Worksheets/QestIds';
import { ResultsSection, WashingSection } from './Sections/HydrometerWash';

const qestIds = [ids.wash.BS_EN_ISO_17892_4_Clause_5_3.Rev2016];

let MeasuredWashHydrometerBsEnIsoWorksheet: WorksheetRootComponent = () => (
  <>
    <WashingSection />
    <ResultsSection />
  </>
);

MeasuredWashHydrometerBsEnIsoWorksheet.qestIds = qestIds;
MeasuredWashHydrometerBsEnIsoWorksheet = withInjectedProps(MeasuredWashHydrometerBsEnIsoWorksheet);

export default MeasuredWashHydrometerBsEnIsoWorksheet;
export { MeasuredWashHydrometerBsEnIsoWorksheet };
